<template>
  <button v-bind:class="[style == 'primary' ? 'primary' : '', style == 'secondary' ? 'secondary' : '', style == 'tetriary' ? 'tetriary' : '', custom]" class="button">{{ label }}</button>
</template>

<script>
export default {
  name: "InputText",
  props:
  [
    "label",
    "style",
    "custom"
  ],
  methods: {
  }
};
</script>

<style scoped lang="postcss">
  .button{
    @apply text-xxs rounded h-8 px-2;
  }
  .primary {
    @apply bg-indigo-600 text-white hover:bg-indigo-700;
  }
  .secondary {
    @apply border border-indigo-600 text-indigo-600 hover:border-indigo-700 hover:text-indigo-700 hover:bg-indigo-100;
  }
  .tetriary {
    @apply border border-gray-100 text-gray-500 hover:border-gray-300 hover:text-gray-800;
  }
</style>